import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=639bb21f&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=639bb21f&prod&lang=scss"
import style1 from "./Questions.vue?vue&type=style&index=1&id=639bb21f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639bb21f",
  null
  
)

export default component.exports